export const SEGMENT_WARNING_COPY = {
  'ID_LIST': {
    heading: 'Drift segments just got more powerful.',
    body: 'This segment was created on or before August 16, 2018. Since then, we’ve added the power to create filter sets separated by ands and ors, making segments in Drift more powerful! You’ll be able to continue using this segment, but to rename it, you’ll need to convert it to the new format.',
    canConvert: false
  },
  'QUERY': {
    heading: 'Drift segments just got more powerful.',
    body: 'This segment was created on or before August 16, 2018. Since then, we’ve added the power to create filter sets separated by ands and ors, making segments in Drift more powerful! You’ll be able to continue using this segment, but to rename it, you’ll need to convert it to the new format.',
    canConvert: true
  }
}